import React from 'react';
import { Link } from 'gatsby';
import { MENU } from "../utils/enums";
import logo from "../images/logo.svg";
import iconfb from "../images/iconfb.svg";
import iconinsta from "../images/iconinsta.svg";
import icontwitter from "../images/icontwitter.svg";

const Footer = () => (
    <footer>
        <div className='container d-flex flex-md-row justify-content-between flex-column footer-cntr'>
            {/* Left Section */}
            <div className='d-flex flex-column'>
                <div>
                    <img src={logo} alt='logo' />
                </div>

                <p className='my-4 font-small'>800-555-1212 | info@facex.com</p>

                <div className='d-flex flex-row justify-content-start social-icons'>
                    <img src={iconfb} alt='fb' width='20' height='20'/>
                    <img src={iconinsta} alt='insta' width='20' height='20'/>
                    <img src={icontwitter} alt='twitter' width='20' height='20'/>
                </div>
            </div>

            {/* Right Section */}
            <div className='d-flex flex-column align-items-start align-items-sm-end'>
                <div className='d-flex flex-row links-sec order-2 flex-wrap justify-content-between mb-5'>
                    {MENU.map((item) => {
                        return <Link className='links' key={item.path} to={item.path}>{item.label}</Link>
                    })}
                </div>

                <div className='text-section order-0 d-flex flex-column align-items-start align-items-sm-end'>
                    <h5 className='mb-0 text-uppercase'>stay in the know.</h5>
                    <p className='font-small'>Check back for updates and our grand opening.</p>
                </div>

                <form className="form-inline mb-5 contact-form order-1">
                    <input type="email" className="form-control email" id="email" placeholder='EMAIL ADDRESS'/>
                    <button type="submit" className="btn btn-primary pl-3 pr-3 join">join</button>
                </form>

                <p className='text-uppercase font-small order-3'>copyright 	&copy; 2018 - facex</p>
            </div>
        </div>
    </footer>
)

export default Footer;
